import Vue from 'vue'
import App from './App'
import router from '@/router/insurance/1an'
import MintUI from 'mint-ui'
import store from '@/store/insurance/1an'
import 'mint-ui/lib/style.css'
import '@/style/common/public.css';
import '@/style/insurance/1anPublic.css';
import 'lib-flexible'
import 'babel-polyfill'
import FastClick from 'fastclick'

require('@/assets/icon/iconfont');

Vue.config.productionTip = false

Vue.use(MintUI)

window.onresize = setHtmlFontSize;
function setHtmlFontSize(){
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();

//IOS11 已经修复了300秒延迟。在11上应用fastclick反而会卡顿 input点击不了的
const str= navigator.userAgent.toLowerCase()
const ver=str.match(/cpu iphone os (.*?) like mac os/)
if(!ver){//非IOS系统
  FastClick.attach(document.body);
} else {
  if(parseInt(ver[1])< 11){
    FastClick.attach(document.body);
  }
}

//添加百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?978cdeb6cc81ccc1e77d80e2c072a97a";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/modules/goodlink/index.js